import { Diagnostic } from "@fairfleet/geotab";
import { Preset } from "@/models/Preset";

export default function diagnosticsToPreset(
  description: string,
  diagnostics: Diagnostic[] | string[],
  groupId: string,
): Preset {
  return {
    description,
    groups: [{ id: groupId }],
    columns: diagnostics.map((d, i) => ({
      columnSequence: i + 1,
      diagnostic: {
        id: typeof d === "string" ? d : d.id,
        name: typeof d === "string" ? "" : d.name,
      },
    })),
    id: description,
  } as Preset;
}
